import { toast } from "react-toastify";
import { fetchCanvasColors } from "../../../utils/truInkTemplate";

export const loadCanvasColors = async (tenantId, setIsLoadingColors, setCanvasColors, setFormData) => {
      if (!tenantId) {
            toast.error('Tenant ID not available for loading canvas colors');
            return;
      }
      setIsLoadingColors(true);
      try {
            const colorsData = await fetchCanvasColors(tenantId);
            if (colorsData && Array.isArray(colorsData)) {
                  setCanvasColors(colorsData);
                  if (colorsData.length > 0) {
                        const defaultColor = colorsData.find(color => color.isDefault) || colorsData[0];
                        if (defaultColor && defaultColor.id) {
                              setFormData(prev => ({
                                    ...prev,
                                    selectableColor: defaultColor.id
                              }));
                        }
                  }
            }
      } catch (error) {
            console.error('Error loading canvas colors:', error);
      } finally {
            setIsLoadingColors(false);
      }
};
